import { useState } from 'react';

export const useForm = (): Form => {
  const [id, setId] = useState('');
  const [article_code, setArticleCode] = useState('');
  const [article_description, setArticleDescription] = useState('');
  const [quantity, setQuantity] = useState(0);
  const [program, setProgram] = useState('');
  const [startDate, setStartDate] = useState(Date.now());
  const [endDate, setEndDate] = useState(Date.now());
  const [errors, setErrors] = useState<Record<string, boolean>>({});

  return {
    fields: {
      id: {
        type: 'text',
        value: id,
        onChange: (v) => {
          setId(String(v));
          setErrors((prev) => ({ ...prev, id: !v }));
        },
        required: true,
        theme: check_theme(errors, 'id', id),
      },
      article_code: {
        type: 'text',
        value: article_code,
        onChange: (v) => {
          setArticleCode(String(v));
          setErrors((prev) => ({ ...prev, article_code: !v }));
        },
        required: true,
        theme: check_theme(errors, 'article_code', article_code),
      },
      article_description: {
        type: 'text',
        value: article_description,
        onChange: (v) => setArticleDescription(String(v)),
      },
      quantity: {
        type: 'number',
        value: quantity,
        onChange: (v) => {
          setQuantity(Math.max(0, Number(v)));
          setErrors((prev) => ({ ...prev, quantity: !Number(v) }));
        },
        required: true,
        theme: check_theme(errors, 'quantity', quantity),
      },
      program: {
        type: 'text',
        value: program,
        onChange: (v) => {
          setProgram(String(v));
          setErrors((prev) => ({ ...prev, program: !v }));
        },
        required: true,
        theme: check_theme(errors, 'program', program),
      },
      startDate: {
        value: startDate,
        onChange: (v) => setStartDate(Number(v)),
      },
      endDate: {
        value: endDate,
        onChange: (v) => setEndDate(Number(v)),
      },
    },
    onSubmit: (cb) => {
      console.log('submitting');
      if (Object.values(errors).some((v) => v)) return;
      cb();
    },
    errors,
    isNew: Object.values(errors).length === 0,
    hasErrors: Object.values(errors).some((v) => v),
    valid:
      id.length > 0 &&
      article_code.length > 0 &&
      quantity > 0 &&
      program.length > 0,
  };
};

type Form = {
  fields: Record<
    string,
    {
      value: string | number;
      onChange: (v: string | number) => void;
      type?: 'text' | 'number';
      required?: boolean;
      theme?: 'valid' | 'error' | 'warning' | 'scheduled';
    }
  >;
  onSubmit: (cb: (...args: any) => void) => void;
  errors: Record<string, boolean>;
  valid: boolean;
  hasErrors: boolean;
  isNew: boolean;
};

const check_theme = (
  errors: Record<string, boolean>,
  key: string,
  value: string | number,
) => {
  if (errors[key]) return 'error';
  if (typeof value === 'string' && value.length > 0) return 'valid';
  if (typeof value === 'number' && value > 0) return 'valid';
};
